export default "__VITE_ASSET__3a28cfa2__"